<template>
    <div>
        <!-- 关联事件 -->
        <el-table :data="detail.toEvent">
            <el-table-column label="编号" prop="serialNumber"></el-table-column>
            <el-table-column label="标题" prop="title">
                <template slot-scope="scope">
                    <el-button type="text" @click="toCorrectDetail(scope.row.serialNumber)">{{scope.row.title}}</el-button>
                </template>
            </el-table-column>

            <el-table-column label="事件分类">
                <template slot-scope="scope">
                    {{ scope.row.category | tableVal(eventList,'t') }}
                </template>
            </el-table-column>
            <el-table-column label="报告人" prop="requester"></el-table-column>
            <el-table-column label="指派人" prop="designator"></el-table-column>
            <el-table-column label="创建时间" prop="createTime"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import commonService from "../../../services/common.service"
    export default {
        props:{
            detail:Object,
            eventList:Array
        },
        data() {
            return {

            }
        },

        created() {
            // console.log(this.eventList,'eventList');
        },
        methods: {
            //点击待办或请求中列表名称时跳转对应详情
            toCorrectDetail(val){
                // let sn=val
                // if (sn.indexOf('Eve')>-1) {
                    this.$router.push({path:'/eventDetail',query:{serialNumber:val}})
                // }
                // if (sn.indexOf('Cha')>-1){
                //     this.$router.push({path:'/changeDetail',query:{serialNumber:sn}})
                // }
                // if (sn.indexOf('Dep')>-1){
                //     this.$router.push({path:'/deployDetail',query:{serialNumber:sn}})
                // }
                // if (sn.indexOf('Pro')>-1){
                //     this.$router.push({path:'/problemDetail',query:{serialNumber:sn}})
                // }
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
